import { fromJS } from 'immutable';
import { combineReducers } from 'redux-immutable';
import { Contract as ContractAction } from '@Actions';

export default combineReducers({
  history: (state = fromJS([]), { type, payload }) => {
    switch (type) {
      case ContractAction.FETCH_TRANSFER_REQUEST:
        return fromJS([]);
      case ContractAction.FETCH_TRANSFER_SUCCESS:
        console.log(payload.toJS());
        return payload;
      default:
        return state;
    }
  },
  historyLoading: (state = '', { type }) => {
    switch (type) {
      case ContractAction.FETCH_TRANSFER_REQUEST:
        return 'start';
      case ContractAction.FETCH_TRANSFER_SUCCESS:
        return 'success';
      case ContractAction.FETCH_TRANSFER_FAILURE:
        return 'failure';
      default:
        return state;
    }
  },
  transfer: (state = fromJS({}), { type, payload }) => {
    switch (type) {
      case ContractAction.TRANSFER_SUCCESS:
        return payload;
      default:
        return state;
    }
  },
  transferLoading: (state = '', { type }) => {
    switch (type) {
      case ContractAction.TRANSFER_REQUEST:
        return 'start';
      case ContractAction.TRANSFER_SUCCESS:
        return 'success';
      case ContractAction.TRANSFER_FAILURE:
        return 'failure';
      default:
        return state;
    }
  },
  userInfo: (state = fromJS({}), { type, payload }) => {
    if (!window.connex) {
      window.sessionStorage.removeItem('userInfo');
    }
    const userinfo = window.connex && window.sessionStorage.getItem('userInfo');
    switch (type) {
      case ContractAction.LOGIN_SUCCESS:
        return payload;
      default:
        return userinfo ? fromJS(JSON.parse(userinfo)) : state;
    }
  },
  loginLoading: (state = '', { type }) => {
    switch (type) {
      case ContractAction.LOGIN_REQUEST:
        return 'start';
      case ContractAction.LOGIN_SUCCESS:
        return 'success';
      case ContractAction.LOGIN_FAILURE:
        return 'failure';
      default:
        return state;
    }
  },
  tokenURI: (state = '', { type, payload }) => {
    switch (type) {
      case ContractAction.FETCH_TOKENURI_REQUEST:
        return '';
      case ContractAction.FETCH_TOKENURI_SUCCESS:
        return payload;
      case ContractAction.FETCH_TRANSFER_FAILURE:
        return '';
      default:
        return state;
    }
  },
  ownerAddress: (state = '', { type, payload }) => {
    switch (type) {
      case ContractAction.FETCH_OWNER_REQUEST:
        return '';
      case ContractAction.FETCH_OWNER_SUCCESS:
        return payload;
      case ContractAction.FETCH_OWNER_FAILURE:
        return '';
      default:
        return state;
    }
  },
});
